import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { Flock, FlockVariant, FlockWeekDataSet, FLOCK_VARIANT } from '../../models/flock.model';
import { BreederFlockOverviewWeekRegistrationDetailed } from '../breeders/flock-overview-week-registration-detailed/flock-overview-week-registration-detailed';
import { FlockOverviewWeekRegistrationDetailedComponent } from '../flock-overview-week-registration-detailed';

@Component({
  selector: 'app-flock-overview-week-registration-detailed-wrapper',
  imports: [
    BreederFlockOverviewWeekRegistrationDetailed,
    FlockOverviewWeekRegistrationDetailedComponent,
  ],
  templateUrl: './flock-overview-week-registration-detailed-wrapper.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlockOverviewWeekRegistrationDetailedWrapper {
  readonly flock = input.required<Flock>();
  readonly flockWeekDataSet = input.required<FlockWeekDataSet>();
  readonly flockVariant = input<FlockVariant>(FLOCK_VARIANT.Layer);

  protected readonly flockVariantEnum = FLOCK_VARIANT;
}
